module.exports = __webpack_public_path__ + "static/media/7-6.a6c893eb.mp3";